<template>
    <div class="loading-container" aria-live="polite">
        <div class="loading">
            <div class="spinner-border text-primary" role="status" >
                <span class="visually-hidden">Chargement en cours</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name:"Loading",
        components: {
    
        },
        props: {
    
        },
        data(){
          return{
    
          }
        }, 
        methods:{

        },
        computed: {
    
        }
    }
</script>

<style scoped>
.loading-container {
    background: rgba(255, 255, 255, .7);
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
}

.loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.loading-container .text-primary {
    color: rgba(13, 110, 253, 1);
}

.loading-container .spinner-border {
    border: 4px solid rgb(13, 110, 253);
    border-right-color: transparent;
    display: inline-block;
    width: 2rem;
    height: 2rem;
    vertical-align: -0.125em;
    border-radius: 50%;
    animation: 0.75s linear infinite spinner-border;
}

.visually-hidden {
        position: absolute!important;
    width: 1px!important;
    height: 1px!important;
    padding: 0!important;
    margin: -1px!important;
    overflow: hidden!important;
    clip: rect(0,0,0,0)!important;
    white-space: nowrap!important;
    border: 0!important;
}

@keyframes spinner-border {
  to { transform: rotate(360deg); }
}
</style>